import { Avatar, Badge, Card, CardHeader } from '../../../../components/ui';
import { money } from '../../../../utils/currency';
import type { CustomerFormValues } from '../../schemas/customerSchema';

/** Live preview of what is being saved, next to the customer form on wide screens. */
export function CustomerSummary({ form, editing }: { form: CustomerFormValues; editing: boolean }) {
  const place = [form.city, 'Maharashtra'].filter(Boolean).join(', ');
  return (
    <Card>
      <CardHeader title="Summary" />
      <div className="flex items-center gap-3 px-5 pt-4">
        <Avatar name={form.name || '?'} size={44} />
        <div className="min-w-0">
          <p className="truncate font-semibold text-navy-900">{form.name.trim() || 'New customer'}</p>
          <p className="truncate text-sm text-ink-500">{form.phone || 'No mobile yet'}</p>
        </div>
      </div>
      <dl className="mt-4 space-y-3 border-t border-line px-5 py-4 text-sm">
        <div className="flex justify-between gap-3">
          <dt className="text-ink-500">Type</dt>
          <dd><Badge tone={form.customerType === 'business' ? 'blue' : 'neutral'}>{form.customerType === 'business' ? 'Business' : 'Individual'}</Badge></dd>
        </div>
        <div className="flex justify-between gap-3">
          <dt className="text-ink-500">Location</dt>
          <dd className="truncate text-right font-medium text-navy-900">{place || '-'}</dd>
        </div>
        <div className="flex justify-between gap-3">
          <dt className="text-ink-500">{form.isAdvance ? 'Advance paid' : 'Old balance'}</dt>
          <dd className="tabular font-medium text-navy-900">{money(form.openingBalance)}</dd>
        </div>
        {editing && (
          <div className="flex justify-between gap-3">
            <dt className="text-ink-500">Status</dt>
            <dd><Badge tone={form.isActive ? 'green' : 'grey'} dot>{form.isActive ? 'Active' : 'Inactive'}</Badge></dd>
          </div>
        )}
      </dl>
    </Card>
  );
}

export default CustomerSummary;
